import React from 'react';
import { Grid } from '@mui/material';
import { PrintWork } from '../PrintWork.js';

export function PrintWorkPage() {
  return (
    <Grid container spacing={1}>
      <PrintWork />
    </Grid>
  );
}
